export default {
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
    visible: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      localVisible: this.visible,
    }
  },
  watch: {
    visible(value) {
      this.localVisible = value
    },
    localVisible(value) {
      this.$emit("update:visible", value)
    },
  },
  methods: {
    show() {
      if (!this.disabled) {
        this.localVisible = true
      }
    },
    hide(force = false) {
      if (!this.disabled || force) {
        this.localVisible = false
      }
    },
    toggle() {
      if (!this.disabled) {
        this.localVisible = !this.localVisible
      }
    },
  },
}
